module.exports = __webpack_public_path__ + "img/cns_ios19.fe79edae.png";